import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import AutosuggestSearch from '@components/common/autosuggest_search/main';
import Checkbox from '@components/common/checkbox/main';
import _ from 'underscore';

const FiletypesFilter = (props) => {
  const [allFileTypes, setAllFileTypes] = useState([]);
  const [visibleFileTypes, setVisibleFileTypes] = useState([]);
  const { filetypes, searchableThings, updateFilters } = props;
  const fileTypesFiltered = filetypes;

  useEffect(() => {
    if (searchableThings.filetypes !== undefined) {
      const allFileTypesUpdated = searchableThings.filetypes.map((filetype) => (
        filetype.extension === "bftemplate"
          ? { extension: "template", count: filetype.count }
          : filetype
      ));

      setAllFileTypes(allFileTypesUpdated);
      setVisibleFileTypes(allFileTypesUpdated.slice(0, 10));
    }
  }, [searchableThings]);

  const checkAndUpdateFileTypes = (filetype) => {
    if (visibleFileTypes.length > 10) {
      const hasFilter = visibleFileTypes.slice(10).filter((filter) => (
        filter.extension === filetype));

      if (hasFilter.length > 0) {
        const visibleFileTypesUpdated = allFileTypes.slice(0, 10);
        setVisibleFileTypes(visibleFileTypesUpdated);
      }
    }

    const filetypeToUdpate = filetype === "template" ? "bftemplate" : filetype;
    updateFilters(filetypeToUdpate);
  };

  const updateFileTypes = (suggestion) => {
    const visibleFileTypesUpdated = [...visibleFileTypes];
    const extension = suggestion.extension === "template" ? "bftemplate" : suggestion.extension;

    updateFilters(extension);
    visibleFileTypesUpdated.push(suggestion);
    setVisibleFileTypes(visibleFileTypesUpdated);
  };

  if (allFileTypes.length <= 0) { return null; }

  return (
    <div className="filter-section filetypes">
      <div className="flex-row title">
        <p>{bfTranslate('Top File Types')}</p>
      </div>
      <div className="tag-columns">
        {visibleFileTypes.map((filetype) => {
          const extension = filetype.extension;
          const count = filetype.count;
          const isChecked = extension === "template"
            ? fileTypesFiltered.indexOf("bftemplate") > -1
            : fileTypesFiltered.indexOf(extension) > -1;
          return (
            <div className="tag-item" key={extension}>
              <Checkbox
                size="sm"
                checked={isChecked}
                toggle={() => checkAndUpdateFileTypes(extension)}
                label={extension}
              />
              <div className="tag-count">
                {count}
              </div>
            </div>
          );
        })}
      </div>
      { _.difference(allFileTypes, visibleFileTypes).length === 0 ? '' : (
        <AutosuggestSearch
          id="filetype-autosuggest"
          allValues={allFileTypes}
          visibleValues={visibleFileTypes}
          onSelect={updateFileTypes}
        />
      )}
    </div>
  );
};

FiletypesFilter.propTypes = {
  filetypes: PropTypes.arrayOf(PropTypes.string),
  searchableThings: PropTypes.shape({}).isRequired,
  updateFilters: PropTypes.func.isRequired,
};

FiletypesFilter.defaultProps = {
  filetypes: [],
};

export default FiletypesFilter;
